import React, { useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../common/types';

import {
    Box, Grid,
    Button, IconButton,
    Tab, Tabs,
    FormHelperText,
    useMediaQuery
} from '@material-ui/core';
import { useStyles } from "./styles";
import * as Icons from "./iconComponents";
import { useForm, FormProvider, Controller } from "react-hook-form";

import SubmitPcrPopup from './SubmitPcrPopup';
import PatientIdentificationTab from "./SubFormWidgets/PatientIdentification";
import SituationTab from "./SubFormWidgets/Situation";
import BackgroundTab from "./SubFormWidgets/Background";
import AssessmentPlanTab from "./SubFormWidgets/AssessmentPlan";
import ActionsInterventionsTab from "./SubFormWidgets/ActionsInterventions";
import MedicationAdminsteredTab from "./SubFormWidgets/MedicationAdminstered";
import ProgressNotesTab from "./SubFormWidgets/ProgressNotes";
import AttachmentsTab from "./SubFormWidgets/Attachments";
import ObservationsTab from "./SubFormWidgets/Observations";
import ObservationCharts from "./SubFormWidgets/ObservationChart";
import HandoverTab from "./SubFormWidgets/Handover";
import IndexedDb from './IndexedDb';
import api from '../../store/api';
import { format, addDays, isToday, isTomorrow, isYesterday } from 'date-fns';
import InfectiousStatusField from './SubFormWidgets/InfectiousStatusField';
import { Settings } from '@material-ui/icons';
import domtoimage from "dom-to-image";
import jsPDF from 'jspdf';
import Observationchart from './Observationchart';
import Caregivers from './SubFormWidgets/Caregivers';
import { v4 as uuidv4 } from 'uuid';
import html2canvas from 'html2canvas';
import { useSelector } from "react-redux";
import { pcrstate } from "../../store/modules/PcrSlice";
import PaperPCR from './SubFormWidgets/PaperPCR';
import { RootState } from "../../store/rootReducer";
import { consts } from "../../common/consts";
interface PcrWidgetProps extends IAppPropsWithRoute {
    id: string | null
};
interface error {
    Message: string | null
}
interface PCRPatientIdentification {
    PCRType: string | null;
    SurName: string | null;
    GivenName: string | null;
    DOB: string | null;
    IsEstimated: boolean | null;
    Gender: number | null;
    MRN: string | null;
    LanguageSpokenAtHome: string | null;
    Aboriginal: string | null;
    HomeAddress: string | null;
    MobilePhone: string | null;
    NextOfKinMobilePhone: string | null;
    IsConsentSurvey: boolean | null;
    NextOfKinName: string | null;
    BookingNumber: string | null;
    IsIdentifiedUsingUniqueIdentifiers: boolean | null;
}
export interface SelectItem extends React.Props<any> {
    text: string | undefined;
    value: string | undefined;
    selected: boolean;
    deleted: boolean;
}
export interface Image extends React.Props<any> {
    column: string | undefined;
    type: string | undefined;
    file: string | undefined;
    imageurl: string | undefined;
    imagesize: string | undefined;
    Base64: string | undefined;
}
export interface AttachemntImage extends React.Props<any> {
    name: string | undefined;
    type: string | undefined;
}
const AddEditPcWidget: React.FC<PcrWidgetProps> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.only("xs"));
    const pcr = useSelector(pcrstate)
    const [loading, setLoading] = React.useState(false);
    const [selectedTab, setSelectedTab] = React.useState(1);
    const [errMsg, setErrMsg] = React.useState([]);
    const [submitPcrPopup, setSubmitPcrPopup] = React.useState(false);
    var [AlteredcallingcriteriaImage] = React.useState<Image>();
    var [TreatmentLimitingOrderPhotoIdb] = useState<Image>();
    var [TraumaChartPhotoIdb] = useState<Image>();
    var [AddPhotoOfCardiacTrace] = useState<Image>();
    const PCRBackgroundAllergies: any = [];
    const MedicationsFields: any = [];
    const ObservationFields: any = [];
    const PCRProgressNotes: any = [];
    const PCRCaregivers: any = [];
    const PCRAttachments: any = [];
    const [Pdf, setPdf] = React.useState("");
    const [PdfResprate, setPdfResprate] = React.useState("");
    const [PdfSat, setPdfSat] = React.useState("");
    const [PdfFr, setPdfFr] = React.useState("");
    const [PdfHr, setPdfHr] = React.useState("");
    const [PdfTemp, setPdfTemp] = React.useState("");
    const [PdfSys, setPdfSys] = React.useState("");
    const [PdfDia, setPdfDia] = React.useState("");
    const [PdfCon, setPdfCon] = React.useState("");
    const [Pdfbgl, setPdfbgl] = React.useState("");
    const [PdfPs, setPdfPs] = React.useState("");
    const [errMsgsave, setErrMsgsave] = React.useState("");
    const [Pdfname, setPdfname] = React.useState("");
    const [saveloading, setsaveloading] = React.useState(false);
    const [careGiversListChanged, setCareGiversListChanged] = React.useState<number>(0);
    const formData = new FormData();
    const formMethods = useForm({
        //shouldUnregister: false,
    });
    const { handleSubmit, watch, trigger, errors, control, formState, setValue, getValues, setError } = formMethods;
    const pcrType = watch("pcr_type");
    const { authStore } = useSelector((state: RootState) => state);

    //let saveloading =false;
    React.useEffect(() => {
        // set default values
        setValue("pcr_type", "1");
        setValue("aboriginal_or_torres", "1");
        setValue("handover_setting", "1");
        getindexdbvalues();
    }, [])

    React.useEffect(() => {
        const onScroll = (e: any): void => {
            let tabValue = 1;
            for (let i = 1; i <= 11; i++) {
                tabValue = i;
                const tabEle = document.querySelector("#pcr_tab_" + i);
                if (tabEle) {
                    var viewportOffset = tabEle.getBoundingClientRect();
                    if (viewportOffset.bottom >= 140 && viewportOffset.top <= window.innerHeight) {
                        break;
                    }
                }
            }
            setSelectedTab(tabValue);
        };
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [])

    const handleTabChange = (event: any, newValue: any): void => {
        if (newValue && newValue > 0) {
            let scrollElement = document.querySelector("#pcr_tab_" + newValue);
            if (scrollElement) {
                scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }
    const handleBack = (): void => {
        history.push("/patientCareRecord");
    }
    const handleDelete = async () => {
        let db = localStorage.getItem("PatientDB");
        if (db != null && db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.deleteValue('Patientidentification', "Delete");
            await indexedDb.putValue('Patientidentification', { column: true, Patid: 0 }, "Delete");
        
            history.push("/patientCareRecord");
            localStorage.removeItem("PatientDB");
        }
    }
    const onSave = async () => {
        let errmsg: any = [];
        try {

            let dbfileupload: any = null;
            let img: any = [];
            dbfileupload = localStorage.getItem("PatientDB");
            if (dbfileupload != null && dbfileupload != "") {
                const indexedDb = new IndexedDb(dbfileupload);
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                let val = await indexedDb.getAllValue('Patientidentification');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "Pdffile") {
                        formData.append('file', val[i].value.column);
                    }
                }
            }

            const resu = await api.pushFileToBlobStorage("", formData);
            if (resu?.error) {
                alert("Error Occurs while Uploading")
            }
            console.table(resu)
            setLoading(true);
            var pcrtypes = 1;
            var transferId = "";
            var CustomerIdb = "0";
            var CustSurnameIdb = "";
            var CustGivenNameIdb = "";
            var DOBIdb = "";
            var EstimatedIdb = false;
            var GenderIdb = "";
            var mrnIdb = "";
            var LanguageIdb = "";
            var AboriginalIdb = "";
            var patientAddressIdb = "";
            var patientAddressGooglePlaceidIdb = "";
            var PatientMobilePhoneIdb = "";
            var SurveyIdb = false;
            var KinMobilePhoneIdb = "";
            var KinNameIdb = "";
            var PatientTranBookNoIdb = "";
            var threeuniqueidentifiers = "";
            var acuityIdb = "0";
            var HandoverReceivedIdb = "";
            var HandoverReceivedRole = "";
            var HandoverReceivedDateIdb = null;
            var HandoverReceivedtimeIdb = null;
            var MultiPrincipleDiagnosisIdb = "";
            var P3jobsIdb = false;
            var PrincipleDiagnosisIdb = "";
            var TimeofPresentationIdb = null;
            var handoverreceivednameIdb = "";
            var pickuplocationIdb = "";
            var pickuplocationGooglePlaceidIdb = "";
            var presentingcomplientIdb = "";
            var WorkplaceinjuryIdb = "";
            var mental_health_drug_alcohol = null;
            var cardiac_monitored = null;
            var Tracheostomy = null;
            var Palliative = null;
            var kgs = null;
            var Obstetric = null;
            var Alteredcallingcriteria = null;
            var Linesdrainsinsitu = null;
            var Paediatric = null;
            var Historyofinjury = null;
            var Relevantmedicalhistory = null;
            var Infectionstatus = null;
            var ListofInfectionstatus = "";
            let observationdata = null;
            var AdditionalRisksIdb = "";
            var CanAmbulateIndependentlyIdb = null;
            var HandoverReceivedtimeIdb = null;
            var ConcernedWithPatientIdb = null;
            var ExistingSkinWoundIdb = null;
            var HasDietaryReactionsIdb = null;
            var HasMedicationSuppliedIdb = null;
            var ListMedicationsIdb = null;
            var HasSignsofCovidIdb = null;
            var HeartRateOutsideFlagsIdb = null;
            var RespRateOutsideFlagsIdb = null;
            var IVSitesShowInfectionIdb = null;
            var IsFallsRiskIdb = null;
            var KnownCognitiveImpairmentIdb = null;
            var MustTransportedViaStretcherIdb = null;
            var O2SaturationOutsideFlagsIdb = null;
            var PatientAgitatedIdb = null;
            var PatientCannotStatePlaceIdb = null;
            var PatientPainScoreIdb = null;
            var PatientPositiveTroponinIdb = null;
            var PhysicalExamfindingIdb = null;
            var PotassiumLevelBelowIdb = null;
            var PreviouslyDiagnosedwithCovidIdb = null;
            var RequiresAidesorAmbulateIdb = null;
            var RequiresAirbornePrecautionsIdb = null;
            var RequiresOxygen4lIdb = null;
            var RespiratoryRateOutsideFlagsIdb = null;
            var SevereAcuteMedicalIllnessIdb = null;
            var SystolicBPOutsideFlagsIdb = null;
            var treatmentlimitingorderIdb = null;
            var OtherInterventions = "";
            var PatientWeight = "0";
            var ResprateRedUpper = 0;
            var ResprateYellowUpper = 0;
            var ResprateRedLower = 0;
            var ResprateYellowLower = 0;
            var OSatRedUpper = 0;
            var OSatYellowUpper = 0;
            var OSatRedLower = 0;
            var OSatYellowLower = 0;
            var OFRedUpper = 0;
            var OFRYellowUpper = 0;
            var OFRRedLower = 0;
            var OFRYellowLower = 0;
            var BPRedUpper = 0;
            var BPYellowUpper = 0;
            var BPRedLower = 0;
            var BPYellowLower = 0;
            var HRRedUpper = 0;
            var HRYellowUpper = 0;
            var HRRedLower = 0;
            var HRYellowLower = 0;
            var TEMPRedUpper = 0;
            var TEMPYellowUpper = 0;
            var TEMPRedLower = 0;
            var TEMPYellowLower = 0;
            var RespiratoryRateMiddle1 = 0;
            var RespiratoryRateMiddle2 = 0;
            var OSaturationMiddle1 = 0;
            var OSaturationMiddle2 = 0;
            var OFlowRateMiddle1 = 0;
            var OFlowRateMiddle2 = 0;
            var BloodPressureMiddle1 = 0;
            var BloodPressureMiddle2 = 0;
            var HeartRateMiddle1 = 0;
            var HeartRateMiddle2 = 0;
            var TemperatureMiddle1 = 0;
            var TemperatureMiddle2 = 0;
            var Handoversetting = 0;
            var Handovername = "";
            var Handoverrole = "";
            var Ambulancenumber = "";
            var Handoverdate = new Date();
            var Handovertime = new Date();
            var Ambulancecalleddate = new Date();
            var Ambulancecalledtime = new Date();
            var Ambulanceonsitedate = new Date();
            var Ambulanceonsitetime = new Date();
            var Ambulancedeptdate = new Date();
            var Ambulancedepttime = new Date();
            var Handoverlocation = "";
            var HandoverlocationGooglePlaceid = "";
            var Otherstaff = "";
            var accessCode = "";
            var ReasonForTransport = "";
            let pdfnames: any = null;
            let db: any = null;
            db = localStorage.getItem("PatientDB");
            if (db != null && db != "") {
                const indexedDb = new IndexedDb(db);
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                let val = await indexedDb.getAllValue('Patientidentification');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "TransferId") {
                        transferId = val[i].value.column;
                    }
                    if (val[i].Key == "CustGivenName") {
                        CustGivenNameIdb = val[i].value.column;
                    }
                    if (val[i].Key == "PCRType") {
                        pcrtypes = (val[i].value.column);
                    }
                    if (val[i].Key == "CustSurName") {
                        CustSurnameIdb = val[i].value.column.toString();
                    }
                    if (val[i].Key == "Customer") {
                        CustomerIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "DOB") {
                        var dates = new Date(val[i].value.column);
                        DOBIdb = (dates).toDateString();
                    }
                    if (val[i].Key == "Estimated") {
                        EstimatedIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "Gender") {
                        GenderIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "mrn") {
                        mrnIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "Language") {
                        LanguageIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "aboriginal") {
                        AboriginalIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "patientAddress") {
                        patientAddressIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "patientAddressgoogleplaceid") {
                        patientAddressGooglePlaceidIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "PatientMobilePhone") {
                        PatientMobilePhoneIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "survey") {
                        SurveyIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "KinMobilePhone") {
                        KinMobilePhoneIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "KinName") {
                        KinNameIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "PatientTranBookNo") {
                        PatientTranBookNoIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "ReasonForTransport") {
                        if (pcrType != 1) ReasonForTransport = val[i].value.column.toString();
                        else ReasonForTransport = "";
                    }
                    if (val[i].Key == "Pdfname") {
                        pdfnames = val[i].value.column;
                    }
                }
                val = await indexedDb.getAllValue('Situation');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "HandoverReceived") {
                        // SetHandoverReceivedIdb(val[i].value.column);
                        HandoverReceivedIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "HandoverReceivedRole") {
                        HandoverReceivedRole = (val[i].value.column);
                        //setValue("handover_received_role",val[i].value.column);
                    }
                    if (val[i].Key == "HandoverReceiveddate") {
                        var dt = new Date(val[i].value.column);
                        HandoverReceivedDateIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "HandoverReceivedtime") {
                        var dt = new Date(val[i].value.column);
                        HandoverReceivedtimeIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "MultiPrincipleDiagnosis") {
                        MultiPrincipleDiagnosisIdb = (val[i].value.column);
                        //setValue("more_information",val[i].value.column);
                    }
                    if (val[i].Key == "P3jobs") {
                        P3jobsIdb = (val[i].value.column);
                        //setValue("p3_job",val[i].value.column);
                    }
                    if (val[i].Key == "PresentingComplaint") {

                        //SetPresentingComplaintIdb(val[i].value.column);
                        presentingcomplientIdb = (val[i].value.column);
                    }

                    if (val[i].Key == "PrincipleDiagnosis") {
                        PrincipleDiagnosisIdb = (val[i].value.column);
                        //setValue("Principle_Diagnosis",val[i].value.column);
                    }
                    if (val[i].Key == "TimeofPresentation") {
                        TimeofPresentationIdb = (val[i].value.column);
                        //setValue("time_of_presentation",val[i].value.column);
                    }
                    if (val[i].Key == "handoverreceivedname") {
                        handoverreceivednameIdb = (val[i].value.column);
                        //setValue("handover_received_name",val[i].value.column);
                    }
                    if (val[i].Key == "pickuplocation") {
                        pickuplocationIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "pickuplocationgoogleplaceid") {
                        pickuplocationGooglePlaceidIdb = (val[i].value.column);
                    }
                    if (val[i].Key == "acuity") {
                        acuityIdb = (val[i].value.column);
                    }

                    if (val[i].Key == "Workplaceinjury") {
                        WorkplaceinjuryIdb = (val[i].value.column);
                    }
                }
                val = await indexedDb.getAllValue('background');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "Mentalhealth,drug&alcohol") {
                        mental_health_drug_alcohol = (val[i].value.column);
                    }
                    if (val[i].Key == "Cardiacmonitored") {
                        cardiac_monitored = (val[i].value.column);
                    }
                    if (val[i].Key == "Tracheostomy") {
                        Tracheostomy = (val[i].value.column);
                    }
                    if (val[i].Key == "Palliative") {
                        Palliative = (val[i].value.column);
                    }
                    if (val[i].Key == "140kgs") {
                        kgs = (val[i].value.column);
                    }
                    if (val[i].Key == "Obstetric") {
                        Obstetric = (val[i].value.column);
                    }
                    if (val[i].Key == "Alteredcallingcriteria") {
                        Alteredcallingcriteria = (val[i].value.column);
                        observationdata = val[i].value.column;

                    }
                    if (val[i].Key.includes("Allergies")) {
                        let res = val[i].value;
                        PCRBackgroundAllergies.push(res);
                    }
                    if (val[i].Key == "AlteredcallingcriteriaImage") {
                        AlteredcallingcriteriaImage = (val[i].value);
                    }
                    if (val[i].Key == "Lines/drainsinsitu") {
                        Linesdrainsinsitu = (val[i].value.column);
                    }
                    if (val[i].Key == "Paediatric") {
                        Paediatric = (val[i].value.column);
                    }
                    if (val[i].Key == "Historyofinjury") {
                        Historyofinjury = (val[i].value.column);
                    }
                    if (val[i].Key == "Relevantmedicalhistory") {
                        Relevantmedicalhistory = (val[i].value.column);
                    }
                    if (val[i].Key == "Infectiousstatus") {
                        Infectionstatus = (val[i].value.column);
                        //setInfectiousstatuss(val[i].value.column);
                    }
                    if (val[i].Key == "Infectiousstatusdesc") {
                        ListofInfectionstatus = (val[i].value.column);
                    }
                }
                val = await indexedDb.getAllValue('AssessmentPlan');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "AdditionalRisks") {
                        AdditionalRisksIdb = (val[i].value.column);
                        //setValue("additional_risks",val[i].value.column);
                    }
                    if (val[i].Key == "CanAmbulateIndependently") {
                        CanAmbulateIndependentlyIdb = (val[i].value.column);
                        //setValue("can_ambulate_independently",val[i].value.column);

                        //setValue("patient_identified",val[i].value.column);
                    }
                    if (val[i].Key == "ConcernedWithPatient") {

                        ConcernedWithPatientIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "ExistingSkinWound") {

                        ExistingSkinWoundIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "HasDietaryReactions") {
                        HasDietaryReactionsIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }

                    if (val[i].Key == "HasMedicationSupplied") {
                        HasMedicationSuppliedIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }

                    if (val[i].Key == "ListMedications") {

                        ListMedicationsIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "HasSignsofCovid") {
                        HasSignsofCovidIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "HeartRateOutsideFlags") {
                        HeartRateOutsideFlagsIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "IsFallsRisk") {
                        IsFallsRiskIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }

                    if (val[i].Key == "IVSitesShowInfection") {
                        IVSitesShowInfectionIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "KnownCognitiveImpairment") {
                        KnownCognitiveImpairmentIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "MustTransportedViaStretcher") {
                        MustTransportedViaStretcherIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "O2SaturationOutsideFlags") {
                        O2SaturationOutsideFlagsIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "PatientAgitated") {
                        PatientAgitatedIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "PatientCannotStatePlace") {
                        PatientCannotStatePlaceIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "PatientPainScore") {
                        PatientPainScoreIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "PatientPositiveTroponin") {
                        PatientPositiveTroponinIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "PhysicalExamfinding") {
                        PhysicalExamfindingIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "PotassiumLevelBelow") {
                        PotassiumLevelBelowIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "PreviouslyDiagnosedwithCovid") {
                        PreviouslyDiagnosedwithCovidIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "RequiresAidesorAmbulate") {
                        RequiresAidesorAmbulateIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "RequiresAirbornePrecautions") {
                        RequiresAirbornePrecautionsIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "RequiresOxygen4l") {
                        RequiresOxygen4lIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "RespiratoryRateOutsideFlags") {
                        RespiratoryRateOutsideFlagsIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "SevereAcuteMedicalIllness") {
                        SevereAcuteMedicalIllnessIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "SystolicBPOutsideFlags") {

                        SystolicBPOutsideFlagsIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "TreatmentLimitingOrderPhoto") {

                        TreatmentLimitingOrderPhotoIdb = (val[i].value);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "traumachartPhoto") {

                        TraumaChartPhotoIdb = (val[i].value);
                        //setValue("surname",val[i].value.column);
                    }
                    if (val[i].Key == "treatmentlimitingorder") {
                        treatmentlimitingorderIdb = (val[i].value.column);
                        //setValue("surname",val[i].value.column);
                    }

                }
                val = await indexedDb.getAllValue('ActionIntervention');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "OtherInterventions") {
                        OtherInterventions = (val[i].value.column);
                    }
                }
                val = await indexedDb.getAllValue('MedicationAdminstered');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key.includes("Medication")) {
                        let res = val[i].value;
                        MedicationsFields.push(res);
                    }
                }
                val = await indexedDb.getAllValue('Observation');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key.includes("item")) {
                        let res = val[i].value;
                        ObservationFields.push(res);
                    }
                    if (val[i].Key == "AddPhotoOfCardiacTrace") {
                        AddPhotoOfCardiacTrace = (val[i].value);
                    }
                    if (val[i].Key == "PatientWeight") {
                        PatientWeight = (val[i].value.column);
                    }
                }
                if (observationdata == 1) {
                    val = await indexedDb.getAllValue('background');
                    for (let i = 0; i < val.length; i++) {
                        if (val[i].Key == "RespiratoryRateUpperRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                ResprateRedUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "RespiratoryRateUpperYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                ResprateYellowUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "RespiratoryRateMiddle1") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                RespiratoryRateMiddle1 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "RespiratoryRateMiddle2") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                RespiratoryRateMiddle2 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "RespiratoryRateLowerYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                ResprateYellowLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "RespiratoryRateLowerRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                ResprateRedLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂SaturationUpperRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OSatRedUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂SaturationUpperYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OSatYellowUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂SaturationMiddle1") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OSaturationMiddle1 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂SaturationMiddle2") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OSaturationMiddle2 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂SaturationLowerYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OSatYellowLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂SaturationLowerRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OSatRedLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂FlowRateUpperRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OFRedUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂FlowRateUpperYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OFRYellowUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂FlowRateMiddle1") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OFlowRateMiddle1 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂FlowRateMiddle2") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OFlowRateMiddle2 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂FlowRateLowerYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OFRYellowLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "O₂FlowRateLowerRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                OFRRedLower = (val[i].value.column);
                            }
                        }

                        if (val[i].Key == "SystolicBloodPressureUpperRed" || val[i].Key == "BloodPressureUpperRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                BPRedUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "SystolicBloodPressureUpperYellow" || val[i].Key == "BloodPressureUpperYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                BPYellowUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "SystolicBloodPressureMiddle1" || val[i].Key == "BloodPressureMiddle1") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                BloodPressureMiddle1 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "SystolicBloodPressureMiddle2" || val[i].Key == "BloodPressureMiddle2") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                BloodPressureMiddle2 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "SystolicBloodPressureLowerYellow" || val[i].Key == "BloodPressureLowerYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                BPYellowLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "SystolicBloodPressureLowerRed" || val[i].Key == "BloodPressureLowerRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                BPRedLower = (val[i].value.column);
                            }
                        }

                        if (val[i].Key == "HeartRateUpperRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                HRRedUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "HeartRateUpperYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                HRYellowUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "HeartRateMiddle1") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                HeartRateMiddle1 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "HeartRateMiddle2") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                HeartRateMiddle2 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "HeartRateLowerYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                HRYellowLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "HeartRateLowerRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                HRRedLower = (val[i].value.column);
                            }
                        }

                        if (val[i].Key == "TemperatureUpperRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                TEMPRedUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "TemperatureUpperYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                TEMPYellowUpper = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "TemperatureMiddle1") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                TemperatureMiddle1 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "TemperatureMiddle2") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                TemperatureMiddle2 = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "TemperatureLowerYellow") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                TEMPYellowLower = (val[i].value.column);
                            }
                        }
                        if (val[i].Key == "TemperatureLowerRed") {
                            if (val[i].value.column !== '' && val[i].value.column !== null) {
                                TEMPRedLower = (val[i].value.column);
                            }
                        }
                    }
                }
                val = await indexedDb.getAllValue('Handover');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "Handoversetting") {
                        Handoversetting = (val[i].value.column);
                    }
                    if (val[i].Key == "Handoverlocation") {
                        Handoverlocation = (val[i].value.column);

                    }
                    if (val[i].Key == "Handoverlocationgoogleplaceid") {
                        HandoverlocationGooglePlaceid = (val[i].value.column);
                    }
                    if (val[i].Key == "Handovername") {
                        Handovername = (val[i].value.column);
                    }
                    if (val[i].Key == "Handoverrole") {
                        Handoverrole = (val[i].value.column);

                    }
                    if (val[i].Key == "Ambulancenumber") {
                        Ambulancenumber = (val[i].value.column);
                    }
                    if (val[i].Key == "Handoverdate") {
                        var dates = new Date(val[i].value.column);
                        Handoverdate = (dates);

                    }
                    if (val[i].Key == "Handovertime") {
                        var time = new Date(val[i].value.column);
                        Handovertime = (time);

                    }
                    if (val[i].Key == "Ambulancecalleddate") {
                        var dates = new Date(val[i].value.column);
                        Ambulancecalleddate = (dates);
                    }
                    if (val[i].Key == "Ambulancecalledtime") {
                        var time = new Date(val[i].value.column);
                        Ambulancecalledtime = (time);
                    }
                    if (val[i].Key == "Ambulanceonsitedate") {
                        var dates = new Date(val[i].value.column);
                        console.log(dates.toString());
                        Ambulanceonsitedate = (dates);
                    }
                    if (val[i].Key == "Ambulanceonsitetime") {
                        var time = new Date(val[i].value.column);
                        Ambulanceonsitetime = (time);
                    }
                    if (val[i].Key == "Ambulancedeptdate") {
                        var dates = new Date(val[i].value.column);
                        console.log(dates.toString());
                        Ambulancedeptdate = (dates);
                    }
                    if (val[i].Key == "Ambulancedepttime") {
                        var time = new Date(val[i].value.column);
                        Ambulancedepttime = (time);
                    }
                    if (val[i].Key == "Otherstaff") {
                        Otherstaff = val[i].value.column;
                    }

                }
                val = await indexedDb.getAllValue('ProgressNotes');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key.includes("ProgressNotes")) {
                        let res = val[i].value;
                        PCRProgressNotes.push(res);
                    }
                }
                val = await indexedDb.getAllValue('Caregivers');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key.includes("caregivers")) {
                        let res = val[i].value;
                        PCRCaregivers.push(res.column);
                    }
                }
                val = await indexedDb.getAllValue('Attachement');
                for (let i = 0; i < val.length; i++) {

                    if (val[i].Key.includes("AlteredCallingCriteriaImg")) {
                        PCRAttachments.push({
                            name: val[i].value.img.name,
                            type: val[i].value.img.type,
                            base64: null,
                            section: "Attachments"
                        });
                    }
                    if (val[i].Key.includes("AddPhotoOfCardiacTrace")) {
                        PCRAttachments.push({
                            name: val[i].value.img.name,
                            type: val[i].value.img.type,
                            base64: null,
                            section: "Photo Of Cardiac Trace"
                        });
                    }
                    if (val[i].Key.includes("TraumachartPhoto")) {
                        PCRAttachments.push({
                            name: val[i].value.img.name,
                            type: val[i].value.img.type,
                            base64: null,
                            section: "Trauma Chart"
                        });
                    }
                    
                    if (val[i].Key.includes("PaperPCRImage")) {
                        PCRAttachments.push({
                            name: val[i].value.img.name,
                            type: val[i].value.img.type,
                            base64: null,
                            section: "Paper PCR"
                        });
                    }
                }
            }
            let _req: { [index: string]: any } = {
                customerID: CustomerIdb ?? null,
                transferId: transferId ?? null,
                givenname: CustGivenNameIdb ?? null,
                pCRType: pcrType ?? null,
                surName: CustSurnameIdb ?? null,
                dOB: format(new Date(DOBIdb), "yyyy-MM-dd") ?? null,
                isEstimated: EstimatedIdb ?? false,
                gender: GenderIdb ?? null,
                mRN: mrnIdb ?? null,
                languageSpokenAtHome: LanguageIdb ?? null,
                aboriginal: AboriginalIdb ?? null,
                homeAddress: patientAddressIdb ?? null,
                homeAddressGooglePlaceid: patientAddressGooglePlaceidIdb ?? null,
                mobilePhone: PatientMobilePhoneIdb ?? null,
                nextOfKinMobilePhone: KinMobilePhoneIdb ?? null,
                isConsentSurvey: SurveyIdb ?? false,
                nextOfKinName: KinNameIdb ?? null,
                bookingNumber: PatientTranBookNoIdb ?? null,
                isIdentifiedUsingUniqueIdentifiers: threeuniqueidentifiers === "1" ? true : false,
                //situation   
                pickupLocation: pickuplocationIdb ?? "",
                pickupLocationGooglePlaceid: pickuplocationGooglePlaceidIdb ?? "",
                principalDiagnosis: PrincipleDiagnosisIdb ?? "",
                principalDiagnosisMoreInfo: MultiPrincipleDiagnosisIdb ?? "",
                handoverReceivedFromName: handoverreceivednameIdb ?? "",
                handoverReceivedFromRole: HandoverReceivedRole ?? "",
                handoversituationDate: format(new Date(HandoverReceivedDateIdb), "yyyy-MM-dd") ?? null,
                Handoversituationtime: HandoverReceivedtimeIdb != null ? format(new Date(HandoverReceivedtimeIdb), "HH:mm:ss").toString() : null,
                acuity: acuityIdb != null && acuityIdb != "" ? acuityIdb : "0",
                isP3Job: P3jobsIdb ?? false,
                presentingComplaint: presentingcomplientIdb ?? "",
                timeOfPresentation: format(new Date(TimeofPresentationIdb), "HH:mm:ss").toString() ?? null,
                workplaceInjury: WorkplaceinjuryIdb !== null ? true : null,
                // //Background
                isMentalHealthDrugAlcohol: mental_health_drug_alcohol === 1 ? true : false,
                isObstetric: Obstetric === 1 ? true : false,
                isCardiacMonitored: cardiac_monitored === 1 ? true : false,
                isAlteredCallingCriteria: Alteredcallingcriteria === 1 ? true : false,
                isTracheostomy: Tracheostomy === 1 ? true : false,
                isLinesDrainsInsitu: Linesdrainsinsitu === 1 ? true : false,
                isPalliative: Palliative === 1 ? true : false,
                isPaediatric: Paediatric === 1 ? true : false,
                isAbove140kgs: kgs === 1 ? true : false,
                isInfectiousStatus: Infectionstatus === 1 ? true : false,
                listAnyActiveInfections: ListofInfectionstatus ?? "",
                relevantMedicalHistory: Relevantmedicalhistory ?? "",
                historyOfPresentingInjury: Historyofinjury ?? "",
                pCRBackgroundAllergies: PCRBackgroundAllergies ?? null,
                alteredCallingCriteriaFileSize: AlteredcallingcriteriaImage?.imagesize?.toString() ?? null,
                alteredCallingCriteriaFileName: AlteredcallingcriteriaImage?.file ?? null,
                alteredCallingCriteriaExtention: AlteredcallingcriteriaImage?.type?.split("/")[1].toString() ?? null,
                alteredCallingCriteriaContentType: AlteredcallingcriteriaImage?.type ?? null,
                alteredCallingCriteriaImage: null,
                // //Assessment                   
                isAlteredCalTreatmentLimitingOrderPhotoContentTypelingCriteria: treatmentlimitingorderIdb === 1 ? true : false,
                isCanAmbulateIndependently: CanAmbulateIndependentlyIdb === 1 ? true : false,
                isRequiresAideAssistanceToAmbulate: RequiresAidesorAmbulateIdb === 1 ? true : false,
                isMustBeTransportedStretcher: MustTransportedViaStretcherIdb === 1 ? true : false,
                isRequiresAirbornePrecautions: RequiresAirbornePrecautionsIdb === 1 ? true : false,
                hasSignsOfCovid: HasSignsofCovidIdb === 1 ? true : false,
                isPreviouslyDiagnosedWithCovid: PreviouslyDiagnosedwithCovidIdb === 1 ? true : false,
                hasDietaryRestrictions: HasDietaryReactionsIdb === 1 ? true : false,
                isaFallsRisk: IsFallsRiskIdb === 1 ? true : false,
                hasMedicationSupplied: HasMedicationSuppliedIdb === 1 ? true : false,
                listOfSuppliedMedications: ListMedicationsIdb ?? null,
                isSevereAcuteMedicalIllness: SevereAcuteMedicalIllnessIdb === 1 ? true : false,
                isKnownCognitiveImpairment: KnownCognitiveImpairmentIdb === 1 ? true : false,
                isPatientAgitatedDifficultToRouseNotAlert: PatientAgitatedIdb === 1 ? true : false,
                isRequiresOxygen4LMin: RequiresOxygen4lIdb === 1 ? true : false,
                isExistingSkinWoundTransport: ExistingSkinWoundIdb === 1 ? true : false,
                isConcernedWithThisPatient: ConcernedWithPatientIdb === 1 ? true : false,
                isPatientPainScore5Of10: PatientPainScoreIdb === 1 ? true : false,
                isHeartRateOutsideTheFlags: HeartRateOutsideFlagsIdb === 1 ? true : false,
                isRespRateOutsideTheFlags: RespiratoryRateOutsideFlagsIdb === 1 ? true : false,
                isSystolicBPOutsideTheFlags: SystolicBPOutsideFlagsIdb === 1 ? true : false,
                isO2SaturationOutsideTheFlags: O2SaturationOutsideFlagsIdb === 1 ? true : false,
                isPatientCannotState: PatientCannotStatePlaceIdb === 1 ? true : false,
                isIVSitesShowInfection: IVSitesShowInfectionIdb === 1 ? true : false,
                isPatassiumLevelBelow: PotassiumLevelBelowIdb === 1 ? true : false,
                isPatientHasPositiveTroponin: PatientPositiveTroponinIdb === 1 ? true : false,
                additionalRisks: AdditionalRisksIdb ?? "",
                primarySurvey: PhysicalExamfindingIdb ?? "",
                treatmentLimitingOrderPhotoFileName: TreatmentLimitingOrderPhotoIdb?.file ?? null,
                treatmentLimitingOrderPhotoExtention: TreatmentLimitingOrderPhotoIdb?.type?.split("/")[1].toString() ?? null,
                treatmentLimitingOrderPhotoContentType: TreatmentLimitingOrderPhotoIdb?.type ?? null,
                treatmentLimitingOrderImage: null,
                traumaChartPhotoFileName: TraumaChartPhotoIdb?.file ?? null,
                traumaChartPhotoFileExtention: TraumaChartPhotoIdb?.type?.split("/")[1].toString() ?? null,
                traumaChartPhotoFileContentType: TraumaChartPhotoIdb?.type ?? null,
                traumaChartPhotoImage: null,
                //Actions
                otherInterventions: OtherInterventions ?? "",
                // Medications
                pCRMedicationsAdministered: MedicationsFields ?? null,
                // Observation       
                pCRObservationData: ObservationFields ?? null,
                addPhotoOfCardiacTraceFileName: AddPhotoOfCardiacTrace?.file ?? null,
                addPhotoOfCardiacTraceExtention: AddPhotoOfCardiacTrace?.type?.split("/")[1].toString() ?? null,
                addPhotoOfCardiacTraceContentType: AddPhotoOfCardiacTrace?.type ?? null,
                addPhotoOfCardiacTraceImage: null,
                patientWeight: PatientWeight != "" && PatientWeight != "0" && PatientWeight != null ? PatientWeight : 0,
                // //Handover
                handovername: Handovername.toString() ?? null,
                ambulanceNumber: Ambulancenumber.toString() ?? null,
                handoverLocation: Handoverlocation.toString() ?? null,
                handoverLocationGooglePlaceid: HandoverlocationGooglePlaceid.toString() ?? null,
                handoverDatetime: format(new Date(Handoverdate), "yyyy-MM-dd") ?? null,
                handoverTime: format(new Date(Handovertime), "HH:mm:ss").toString() ?? null,
                handoverrole: Handoverrole.toString() ?? null,
                ambulanceCalleddate: format(new Date(Ambulancecalleddate), "yyyy-MM-dd") ?? null,
                ambulanceCalledtime: format(new Date(Ambulancecalledtime), "HH:mm:ss").toString() ?? null,
                ambulanceDepartdate: format(new Date(Ambulancedeptdate), "yyyy-MM-dd") ?? null,
                ambulanceDeparttime: format(new Date(Ambulancedepttime), "HH:mm:ss").toString() ?? null,
                ambulanceOnsitedate: format(new Date(Ambulanceonsitedate), "yyyy-MM-dd") ?? null,
                ambulanceOnsitetime: format(new Date(Ambulanceonsitetime), "HH:mm:ss").toString() ?? null,
                setting: Handoversetting ?? null,
                otherStaff: Otherstaff,
                //PCRProgressNotes       
                pCRProgressNotes: PCRProgressNotes ?? null,
                pCRCaregivers: PCRCaregivers[0] ?? null,
                //PCRAttachmentss
                pCRAttachments: PCRAttachments ?? null,
                //PCRObservationBackground
                r1: ResprateRedUpper ?? 0,
                r2: ResprateYellowUpper ?? 0,
                r3: RespiratoryRateMiddle1 ?? 0,
                r4: RespiratoryRateMiddle2 ?? 0,
                r5: ResprateYellowLower ?? 0,
                r6: ResprateRedLower ?? 0,
                s1: OSatRedUpper ?? 0,
                s2: OSatYellowUpper ?? 0,
                s3: OSaturationMiddle1 ?? 0,
                s4: OSaturationMiddle2 ?? 0,
                s5: OSatYellowLower ?? 0,
                s6: OSatRedLower ?? 0,
                f1: OFRedUpper ?? 0,
                f2: OFRYellowUpper ?? 0,
                f3: OFlowRateMiddle1 ?? 0,
                f4: OFlowRateMiddle2 ?? 0,
                f5: OFRYellowLower ?? 0,
                f6: OFRRedLower ?? 0,
                bP1: BPRedUpper ?? 0,
                bP2: BPYellowUpper ?? 0,
                bP3: BloodPressureMiddle1 ?? 0,
                bP4: BloodPressureMiddle2 ?? 0,
                bP5: BPYellowLower ?? 0,
                bP6: BPRedLower ?? 0,
                hR1: HRRedUpper ?? 0,
                hR2: HRYellowUpper ?? 0,
                hR3: HeartRateMiddle1 ?? 0,
                hR4: HeartRateMiddle2 ?? 0,
                hR5: HRYellowLower ?? 0,
                hR6: HRRedLower ?? 0,
                t1: TEMPRedUpper ?? 0,
                t2: TEMPYellowUpper ?? 0,
                t3: TemperatureMiddle1 ?? 0,
                t4: TemperatureMiddle2 ?? 0,
                t5: TEMPYellowLower ?? 0,
                t6: TEMPRedLower ?? 0,
                pcrpdf: null,
                pcrpdfResprate: null,
                pcrpdfSat: null,
                pcrpdfFlowrate: null,
                pcrpdfSys: null,
                pcrpdfDia: null,
                pcrpdfHeartrate: null,
                pcrpdfTemp: null,
                pcrpdfCon: null,
                pcrpdfBgl: null,
                pcrpdfPs: null,
                accessCode: accessCode,
                reasonForTransport: ReasonForTransport ?? "",
                pdfname: pdfnames
            }
            const res = await api.addNewBookingPCR('', _req);
            if (res.hasError === false) {
                const indexedDb = new IndexedDb(db);
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                await indexedDb.deleteValue('Patientidentification', "Delete");
                await indexedDb.putValue('Patientidentification', { column: true, Patid: 0 }, "Delete");
                // const DBDeleteRequest = window.indexedDB.deleteDatabase(db);
                // DBDeleteRequest.onerror = (event) => {
                //     console.error("Error deleting database.");
                // };

                // DBDeleteRequest.onsuccess = (event) => {
                //     console.log("Database deleted successfully");
                // };
                history.push("/patientCareRecord/thankYou", res.result);
                downloadpdf(res.result.id)
            }
            else {
                setErrMsgsave("An error has occurred. Please try again later")
                console.error(res);
                console.log(res.result);
                setSubmitPcrPopup(false);
            }
        }
        catch (error) {
            console.error(error)
            setErrMsgsave("An error has occurred. Please try again later")
            console.log(error);
            setSubmitPcrPopup(false);
        }
    }

    const downloadpdf = async (pcrid: any) => {
        try {
            await api.downloadBookingPCR(`bookingid=${pcrid}`, "");
        }
        catch (error) {
            console.error(error)
            setErrMsgsave("An error has occurred. Please try again later")
            console.log(error);
        }
    }


    const CharttoPdf = async (divname: any) => {
        const div = window.document.getElementsByClassName("" + divname + "")[0];
        const divHeight = div.clientHeight;
        const divWidth = div.clientWidth;
        const options = { background: 'white', width: divWidth, height: divHeight };

        domtoimage.toPng(div, options).then((imgData: any) => {
            const doc = new jsPDF('p', 'mm', [divWidth, divHeight]);
            const imgProps = doc.getImageProperties(imgData);
            const pdfWidth = doc.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            doc.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            if (divname === "RespiratoryRate") {
                setPdfResprate(imgData);
            }
            if (divname === "Saturation") {
                setPdfSat(imgData);
            }
            if (divname === "FlowRate") {
                setPdfFr(imgData);
            }
            if (divname === "Systolic") {
                setPdfSys(imgData);
            }
            if (divname === "Diastolic") {
                setPdfDia(imgData);
            }
            if (divname === "HeartRate") {
                setPdfHr(imgData);
            }
            if (divname === "Temperature") {
                setPdfTemp(imgData);
            }
            if (divname === "Consciousness") {
                setPdfCon(imgData);
            }
            if (divname === "bgLevel") {
                setPdfbgl(imgData);
            }
            if (divname === "PainScore") {
                setPdfPs(imgData);
            }
        });
    }
    const onValidate = async () => {
        const validate = await trigger();
        if (validate) {
            setSubmitPcrPopup(true);
        }
        else {
            let error = "";
            let i = 0;
            let errorarr: any = [];
            let erlist: any = [];
            let top3Errors: any;
            if (errors) {
                for (let key in errors) {
                    if (errors[key].length > 0) {
                        var list = errors[key];
                        if (list.length > 0) {
                            for (let j in list) {
                                var list2 = list[j];
                                erlist.push(list2);
                                if (erlist.length > 0) {
                                    for (let item of erlist) {
                                        for (let key in item) {
                                            if (item.hasOwnProperty(key)) {
                                                var innerRow = item[key];
                                                error = innerRow.message;
                                                errorarr.push(error)
                                            }
                                        }
                                    }

                                }
                            }
                        }
                    }
                    else if (errors[key].message) {
                        error = errors[key].message;
                        errorarr.push(error)
                    }

                    if (i > 3) {
                        break;
                    }
                    i++;
                }
                top3Errors = errorarr.slice(0, 3);
            }
            setErrMsg(top3Errors);
        }
    }
    const generateRandomGuid = () => {
        const newGuid = uuidv4();
        return newGuid;
    };


    const saveFiletoBlobStorage = async() : Promise<void> =>  {
        try {
            setLoading(true);
            let db: any = null;
            let img: any = [];
            let pdfnames: any = null;
            db = localStorage.getItem("PatientDB");
            if (db != null && db != "") {
                const indexedDb = new IndexedDb(db);
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                let val = await indexedDb.getAllValue('Patientidentification');
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "Pdffile") {
                        formData.append('file', val[i].value.column);
                    }
                }
            }

            const res = await api.pushFileToBlobStorage("", formData);
            if (res?.error) {
                alert("Error Occurs while Uploading")
            }
            
            if (res != null) {
                setLoading(false);
            }

        } catch (error) {
            setLoading(false);
        }
    };

    const blobToBase64 = (blob: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    };
    const onSubmit = async () => {
        const validate = await trigger();
        localStorage.setItem("Chartdata", "block")
        if (validate) {
            setLoading(true);
            let values = getValues();
            await onSave();

        }
    }
    
    const handleindexdbsaveload = async (value: any): Promise<void> => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        if (db != null || db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            await indexedDb.putValue('Patientidentification', { column: value, Patid: 0 }, "PCRType");
        }
    }
    const getindexdbvalues = async (): Promise<void> => {
        //
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        if (db != null && db != "") {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('Patientidentification');
            if (val != null && val != "") {
                for (let i = 0; i < val.length; i++) {
                    if (val[i].Key == "PCRType") {
                        setValue("pcr_type", val[i].value.column.toString());
                        break;
                    }
                }
            }
        }
        else {
            handleindexdbsaveload(1);
        }
    }

    return (
        <div className={classes.root}>
            <FormProvider {...formMethods}>
                <form onSubmit={(e: any) => e.preventDefault()} autoComplete="off">
                    <div className={classes.pcrAddHeader} id="pcrFixedTop">
                        {errMsg && errMsg.length > 0 && (<>
                            <Grid container className={"errorMsg"}>
                                <Grid item>
                                    <div className={"text"}>
                                        {errMsg.map((item, index) => (
                                            <div>{item}</div>
                                        ))
                                        }
                                    </div>
                                </Grid>
                                <Grid item>
                                    <div className={"icon"} onClick={() => setErrMsg([])}>
                                        <Icons.CloseLightIcon />
                                    </div>
                                </Grid>
                            </Grid>
                        </>)}
                        {errMsgsave !== "" ?
                            <Grid container className={"errorMsg"}>
                                <Grid item>
                                    <div>{errMsgsave}</div>
                                </Grid>
                                <Grid item>
                                    <div className={"icon"} onClick={() => (setErrMsgsave(""), window.location.reload())}>
                                        <Icons.CloseLightIcon />
                                    </div>
                                </Grid>
                            </Grid>
                            : null}
                        <Grid container className={classes.pcrAddNavbar1}>
                            <Grid item>
                                <IconButton onClick={handleBack}>
                                    <Icons.BackLightIcon />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <div id='formStatus'>
                                    {loading ? (<>
                                        Saving...
                                    </>) : (<></>)}
                                </div>
                            </Grid>
                            <Grid item>
                                <IconButton onClick={handleDelete}>
                                    <Icons.DeleteLightIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid container className={classes.pcrAddNavbar2} spacing={0}>
                            <Grid item xs={9} sm={9}>
                                <Tabs value={selectedTab} onChange={handleTabChange} variant="scrollable" scrollButtons="off">
                                    <Tab icon={<Icons.CaregiversIcon />} value={1} />
                                    <Tab icon={<Icons.Tab1Icon />} value={2} />
                                    <Tab icon={<Icons.Tab2Icon />} value={3} />
                                    <Tab icon={<Icons.Tab3Icon />} value={4} />
                                    <Tab icon={<Icons.Tab4Icon />} value={5} />
                                    {pcrType !== "2" && <Tab icon={<Icons.Tab5Icon />} value={6} />}
                                    <Tab icon={<Icons.Tab6Icon />} value={7} />
                                    <Tab icon={<Icons.Tab7Icon />} value={8} />
                                    <Tab icon={<Icons.Tab8Icon />} value={9} />
                                    <Tab icon={<Icons.Tab9Icon />} value={10} />
                                    <Tab icon={<Icons.Tab10Icon />} value={11} />
                                </Tabs>
                            </Grid>
                            <Grid item xs={3} sm={"auto"}>
                                <Button className={classes.submitBtn} type="button" onClick={onValidate} disabled={loading}>
                                    <Icons.SubmitIcon />
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes.pcrAddBody}>
                        <div className={classes.pcrAddTabItem}>
                            <div className={classes.pcrAddHeading}>
                                <div>Patient Care Record</div>
                                <span>Required Fields</span>
                            </div>
                            <div>
                                <Controller
                                    control={control}
                                    name="pcr_type"
                                    defaultValue=""
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.pcrAddFormTypes} spacing={0}>
                                                <Grid item xs={4} sm={4} onClick={(e) => onChange("1", handleindexdbsaveload(1))}>
                                                    <div className={`item ${value === "1" ? "selected" : ""}`}>
                                                        <div className={"content"}>
                                                            <div><Icons.Type1Icon /></div>
                                                            <div>
                                                                Medical <br />Incident
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} sm={4} onClick={(e) => onChange("2", handleindexdbsaveload(2))}>
                                                    <div className={`item ${value === "2" ? "selected" : ""}`}>
                                                        <div className={"content"}>
                                                            <div><Icons.Type2Icon /></div>
                                                            <div>
                                                                Patient <br />Transport
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4} sm={4} onClick={(e) => onChange("3", handleindexdbsaveload(3))}>
                                                    <div className={`item ${value === "3" ? "selected" : ""}`}>
                                                        <div className={"content"}>
                                                            <div><Icons.Type3Icon /></div>
                                                            <div>
                                                                Patient Transport
                                                                {isMobile ? (
                                                                    <span>With Incident</span>
                                                                ) : (
                                                                    <span>Medical Incident <br />En Route</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.pcr_type}>
                                                {errors.pcr_type ? errors.pcr_type.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: "Please select the PCR type",
                                    }}
                                />
                            </div>
                            { authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.PhotoPCRUpload || p == consts.Permissions.SMAPhotoPCRUpload) && 
                            <div className={"pcrPaperSec"}>
                            <PaperPCR /> 
                            </div> }
                        </div>
                        <div className={classes.pcrAddTabItem} id="pcr_tab_1">
                            <Caregivers setCareGiversListChanged={setCareGiversListChanged} />
                        </div>
                        <div className={classes.pcrAddTabItem} id="pcr_tab_2">
                            <PatientIdentificationTab getparentindexdbvalues={getindexdbvalues} />
                        </div>
                        <div className={classes.pcrAddTabItem} id="pcr_tab_3">
                            <SituationTab />
                        </div>
                        <div className={classes.pcrAddTabItem} id="pcr_tab_4">
                            <BackgroundTab />
                        </div>
                        <div className={classes.pcrAddTabItem} id="pcr_tab_5">
                            <AssessmentPlanTab />
                        </div>
                        {pcrType !== "2" && (<div className={classes.pcrAddTabItem} id="pcr_tab_6">
                            <ActionsInterventionsTab />
                        </div>)}
                        <div className={`${classes.pcrAddTabItem} noSpaing`} id="pcr_tab_7">
                            <MedicationAdminsteredTab careGiversListChanged={careGiversListChanged} setCareGiversListChanged={setCareGiversListChanged} />
                        </div>
                        <div className={`${classes.pcrAddTabItem} noSpaing`} id="pcr_tab_8">
                            <ProgressNotesTab />
                        </div>
                        <div className={classes.pcrAddTabItem} id="pcr_tab_9">
                            <AttachmentsTab />
                        </div>
                        <div className={`${classes.pcrAddTabItem} noSpaing`} id="pcr_tab_10">
                            <ObservationsTab />
                        </div>
                        <div className={classes.pcrAddTabItem} id="pcr_tab_11">
                            <HandoverTab />
                        </div>
                    </div>
                    <SubmitPcrPopup
                        popState={submitPcrPopup}
                        setPopState={setSubmitPcrPopup}
                        onSubmit={onSubmit}
                        disabled={loading}
                        setPdfname={setPdfname}
                    />
                </form>
            </FormProvider>
        </div>
    );
}

export default React.memo(withRouter(AddEditPcWidget));